export const addEventListernerWithPromiseForData = (event = 'click') => {
    return new Promise(resolve => {
        document.addEventListener(event, e => {
            resolve(e);
        });
    });
};

export const fireEventWithData = (data:object, event: string = 'click', context:HTMLElement|Document = document) => {

    return new Promise(resolve => {

        const customEvent = new CustomEvent(event, {
            detail: {
                data
            }
        });
        context.dispatchEvent(customEvent);
        resolve(customEvent);
    });

};